<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import type { RescheduleSlotDisplay } from '@/modules/appointments/helpers/rescheduleReason';

const {
  from,
  to,
  showIntro = true
} = defineProps<{
  from: RescheduleSlotDisplay;
  to: RescheduleSlotDisplay;
  showIntro?: boolean;
}>();

const { t } = useI18n();
</script>

<template>
  <div class="d-flex flex-column ga-4">
    <span v-if="showIntro" class="d-block typography-body-md">
      {{
        $t(
          'appointment.dialogs.loadTypeReselectDialog.messages.youAreAboutToRescheduleThisAppointment'
        )
      }}:
    </span>
    <div class="d-flex flex-wrap">
      <div class="d-flex flex-column gap-0-5 flex-grow-1">
        <span class="typography-body-sm-bold">
          {{ t('appointment.forms.rescheduleForm.labels.from') }}
        </span>
        <div class="d-flex flex-column ga-2">
          <span class="typography-body-sm">{{ from.date }}</span>
          <span class="typography-body-sm">{{ from.timeRange }}</span>
          <span v-if="from.dock" class="typography-body-sm-bold">{{ from.dock }}</span>
        </div>
      </div>
      <div class="d-flex flex-column gap-0-5 flex-grow-1">
        <span class="typography-body-sm-bold">
          {{ t('appointment.forms.rescheduleForm.labels.to') }}
        </span>
        <div class="d-flex flex-column ga-2">
          <span class="typography-body-sm">{{ to.date }}</span>
          <span class="typography-body-sm">{{ to.timeRange }}</span>
          <span v-if="to.dock" class="typography-body-sm-bold">{{ to.dock }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
